import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import * as serviceWorker from './serviceWorker';

import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Navbar from './containers/Navbar';

if (localStorage.loggedin) {
  //localStorage.clickcount = Number(localStorage.clickcount) + 1;
} else {
  console.log("setting up for the first time...")
  localStorage.loggedin = "0";
}

ReactDOM.render(
  <div>
    <BrowserRouter>
      <Navbar />
      <App />
    </BrowserRouter>
  </div>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
